import React from 'react';
import PropTypes from 'prop-types';

import BrandItem from '../BrandItem';

const BrandsSection = ({ brands }) => {
  return (
    <section
      className="section"
      style={{ backgroundColor: 'transparent', paddingTop: '45px', paddingBottom: '45px' }}
    >
      <h2 className="section__header__title section__header__title--mb-45">Tüm Markalar</h2>
      <div className="container">
        <div className="row row--mb30 features justify-content-center">
          {brands.map((brand) => (
            <BrandItem key={brand.id} brand={brand} />
          ))}
        </div>
      </div>
    </section>
  );
};

BrandsSection.propTypes = {
  brands: PropTypes.array,
};

export default BrandsSection;
